"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastActionStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _colors = require("../../../constants/colors");
var _spacing = require("../../../constants/spacing");
var _focusRing = require("../../../util/focusRing");
var _withFocusClassName = require("../../../util/withFocusClassName");
const focusRing = (0, _focusRing.getFocusRingStyles)({
  colorOverride: "currentColor",
  offset: 2,
  radius: 6,
  theme: "light",
  includeFocusPseudoClass: true
});
const hoverAndFocusBackground = (0, _colors.toRgba)(_colors.neutralLight40, 0.2);
const pressedBackground = (0, _colors.toRgba)(_colors.neutralDark40, 0.12);
const maybeApplyFocusBackground = _ref => {
  let {
    focusMode
  } = _ref;
  return focusMode === "keyboard" ? `background-color: ${hoverAndFocusBackground};` : "";
};
const ToastActionStyled = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("button")`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    height: 32px;
    min-width: 32px;
    padding: 7px ${_spacing.sizes.xxSmall}px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    color: currentColor;

    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    white-space: nowrap;

    ${focusRing}

    background-color: transparent;

    &:hover {
        background-color: ${hoverAndFocusBackground};
    }

    &:active {
        background-color: ${pressedBackground};
    }

    &:focus {
        ${maybeApplyFocusBackground}
    }
`);
exports.ToastActionStyled = ToastActionStyled;
ToastActionStyled.displayName = "ToastActionContainer";
//# sourceMappingURL=ToastActionStyled.js.map